import React from "react";
import { Authenticator } from "@aws-amplify/ui-react";
import { AuthProvider } from "../features/auth";
import { ImpersonationProvider } from "../features/impersonation";
import { TagAliasProvider } from "../features/tag-aliases";

interface ProvidersProps {
  children: React.ReactNode;
}

/**
 * Root providers component that wraps the app with all necessary context providers.
 * This follows the React best practice of separating app setup from routing logic.
 */
export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <Authenticator.Provider>
      <AuthProvider>
        <ImpersonationProvider>
          {/* Below impersonation: the map is per-workspace, so it must refetch
              when a staff session switches which workspace it is viewing. */}
          <TagAliasProvider>{children}</TagAliasProvider>
        </ImpersonationProvider>
      </AuthProvider>
    </Authenticator.Provider>
  );
};
